import firebase from 'firebase/app';
import 'firebase/firestore';
var firebaseConfig = {
  apiKey: "AIzaSyBG1ghlquzGw4CltaO0fjkGu2Rq1asTaYQ",
  projectId: "postcards-4bbc9",
  authDomain: "postcards-4bbc9.firebaseapp.com",
  databaseURL: "https://postcards-4bbc9.firebaseio.com",
  messagingSenderId: "343558008296"
};
firebase.initializeApp(firebaseConfig);
export default firebase.firestore();